import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import frLocales from "./langs/fr.json";

// 🌍 Le site démarre toujours en français. L'anglais (en.json, environ 130 Ko) est chargé à part depuis
// le tour 50, la première fois qu'on passe en anglais (pied de page, menus, lien d'un e-mail) : il
// n'est plus dans le fichier principal que télécharge chaque visiteur. i18next attend la fin du
// chargement pour changer de langue, la page reste en français jusque-là. Dans les tests, les deux
// langues sont chargées tout de suite, comme avant.
const englishLoader = {
  type: "backend",
  init() {},
  read(language, namespace, callback) {
    if (language !== "en") return callback(null, {});
    import(/* webpackChunkName: "langue-en" */ "./langs/en.json")
      .then((m) => callback(null, (m.default || m).translation))
      .catch((error) => callback(error, null));
  },
};
const testResources = process.env.NODE_ENV === "test" ? { en: { ...require("./langs/en.json") } } : {};

i18n
  .use(englishLoader)
  .use(initReactI18next)
  .init({
    resources: {
      ...testResources,
      fr: { ...frLocales },
    },
    // Langues fournies ici, les autres demandées au chargeur ci-dessus
    partialBundledLanguages: true,
    lng: "fr",
    // React échappe déjà tout le texte affiché : sans cela, i18next échappait aussi les valeurs
    // interpolées, et l'écran montrait « 18&#x2F;10 10:15 » ou « l&#39;élève » au lieu de « 18/10 10:15 ».
    // Aucune traduction n'est insérée en HTML brut (dangerouslySetInnerHTML : contenus du CMS seulement).
    interpolation: { escapeValue: false },
  });
